import Topnav from './components/Nav/TopBar';
import Sidebar from './components/Nav/SideBar';

import { useStateContext } from './components/Context/ContextProvider';
import AuthToken from './components/Context/AuthToken';
import ProtectedRoute from './components/Context/ProtectedRoute';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

import Home from './pages/Home';
import Login from './pages/Login';
import Customers from './pages/Customer/Customers'
import ViewCustomer from './pages/Customer/ViewCustomer'
import ListUsers from './pages/Admins/ListAdmins'
import AddUsers from './pages/Admins/AddAdmin'
import UpdateUser from './pages/Admins/UpdateAdmin'
import Profile from './pages/Admins/Profile'
import Successful from './pages/Requests/Successful'
import Failed from './pages/Requests/Failed'
import Reversed from './pages/Requests/Reversed'
import C2bConfirmation from './pages/Payments/C2bConfirmation'
import StkResultCdr from './pages/Payments/StkResultCdr'
import StkPushArchieve from './pages/Payments/StkPushArchieve'
import MpesaPullResult from './pages/Payments/MpesaPullResult'
import StkReport from './pages/Reports/StkReport'
import Balances from './pages/Reports/Balance'
import Promocode from './pages/Reports/Promocode'


const App = () => {
  const { activeMenu } = useStateContext();

  const { accessToken, setAccessToken } = AuthToken();
  if (!accessToken) {
    return <Login setAccessToken={setAccessToken} />;
  }

  return (
    <main>
      <div className='flex relative'>
        {activeMenu ? (
          <div className='lg:w-48 xl:w-52 2xl:w-60 fixed'>
            <Sidebar />
          </div>
        ) : (
          <div>
            <Sidebar />
          </div>
        )}
        <div className={activeMenu ? 'min-h-screen lg:ml-48 xl:ml-52 2xl:ml-60 w-full' : 'w-full min-h-screen flex-2'}>
          <div>
            <Topnav />
          </div>
          <div>
            <Toaster position='top-center' richColors />
            <Routes>
              {/* dashboard  */}
              <Route path='/' element={<Home />} />
              <Route path='/login' element={<Login setAccessToken={setAccessToken} />} />
              <Route path='/customers' element={<Customers />} />
              <Route path='/customer/:id' element={<ViewCustomer />} />
              {/* <Route path='/admins' element={<ProtectedRoute><ListUsers /></ProtectedRoute>} />
              <Route path='/addadmin' element={<ProtectedRoute><AddUsers /></ProtectedRoute>} />
              <Route path='/updateadmin/:id' element={<ProtectedRoute><UpdateUser /></ProtectedRoute>} /> */}
              <Route path='/my-profile' element={<Profile />} />
              <Route path='/successful' element={<Successful />} />
              <Route path='/failed' element={<Failed />} />
              <Route path='/reversed' element={<Reversed />} />
              <Route path='/c2b-confirmation' element={<C2bConfirmation />} />
              <Route path='/stk-result-cdr' element={<StkResultCdr />} />
              <Route path='/stk-push-archieve' element={<StkPushArchieve />} />
              <Route path='/mpesa-pull-result' element={<MpesaPullResult />} />
              <Route path='/stk-reports' element={<StkReport />} />
              <Route path='/balances' element={<Balances />} />
              <Route path='/promocode' element={<Promocode />} />
            </Routes>
          </div>
        </div>
      </div>
    </main>
  );
};

export default App;
